// extracted by mini-css-extract-plugin
module.exports = {"main":"skills_main__3fwj7","skill":"skills_skill__2Mlu-","title":"skills_title__xl7nw","bar":"skills_bar__2i1rZ"};